/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum AuditType {
  ORDER_CREATED = 'order_created',
  ORDER_UPDATED = 'order_updated',
  ORDER_DELETED = 'order_deleted',
  EVENT_CREATED = 'event_created',
  EVENT_UPDATED = 'event_updated',
  EVENT_DELETED = 'event_deleted',
  ORDER_CONVERTED_TO_VOUCHER = 'order_converted_to_voucher',
  VOUCHER_CREATED_FROM_ORDER = 'voucher_created_from_order',
  VOUCHER_CONVERTED_TO_ORDER = 'voucher_converted_to_order',
  ORDER_CREATED_FROM_VOUCHER = 'order_created_from_voucher',
  PAYMENT_LINK_CREATED = 'payment_link_created',
  PAYMENT_LINK_PAID = 'payment_link_paid',
}
